import React from 'react';

import LibraryQuestion from './LibraryQuestion';

function DocumentData() {
  return <>
    <div className="col">
      <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>Question Library</h5>

      <LibraryQuestion />
    </div>
  </>
}

export default DocumentData;